import React, { Fragment } from 'react'
import { Route } from 'react-router-dom'
import ListAgencies from './ListAgencies'
import AgencyCard from './AgencyCard'
import NewAgencyPage from './NewAgencyPage'
import EditAgencyPage from './EditAgencyPage'
import ResourceDetails from '../UI/ResourceDetails'

const AgencyDetails = ({ match }) => (
  <ResourceDetails
    resourceAPIEndpoint="agencies"
    nameAttribute="name"
    clientRootPath="/agencies"
    resourceSingularName="agency"
    detailsCard={AgencyCard}
    match={match}
  />
)

const Agencies = ({ match }) => (
  <Fragment>
    <Route path={match.url + '/'} component={ListAgencies} />
    <Route exact path={match.url + '/new'} component={NewAgencyPage} />
    <Route path={match.url + '/:id/edit'} component={EditAgencyPage} />
    <Route path={match.url + '/:id'} component={AgencyDetails} />
  </Fragment>
)

export default Agencies



// WEBPACK FOOTER //
// ./src/components/Agencies/Agencies.jsx